module.exports = __webpack_public_path__ + "img/reflect.5579c0a9.png";